import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  TextTitle,
  ValidatedPanel,
  getPanelErrorProps,
} from '@bingads-webui-campaign/wizard-jumbo-card';
import { ImageListPortalContainerWithControlErrorHandling } from './image-list-portal-container';
import { ImageListSummaryCardDetails } from './image-list-card-details';
import LogoAssetsImg from '../media/logo-assets.svg';

export const LogoListPortalContainerSection = ({
  expand,
  images,
  containerRef,
  containerState,
  ...rest
}) => {
  const i18n = useContext(I18nContext);
  return (
    <ValidatedPanel
      key="logos"
      title={<TextTitle
        titleKey={_TL_('Logos')}
        icon={LogoAssetsImg}
        iconAltText={i18n.getString(_TL_('"Logos" panel\'s image'))}
        topicKey="pop_BA_CampaignCreate_MMA_Logos"
        details={<ImageListSummaryCardDetails i18n={i18n} images={images} isLogos />}
      />}
      attentionBeaconProps={{ getExtraProps: getPanelErrorProps }}
      actuationProps={{
        expand,
        expandKey: 'logos',
      }}
      {...rest}
    >
      <span>{i18n.getString(_TL_('You can add up to 5 different logos. Each logo can have one or both 4:1 aspect ratio and 1:1 aspect ratio.'))}</span>
      <ImageListPortalContainerWithControlErrorHandling
        i18n={i18n}
        containerRef={containerRef}
        containerState={containerState}
        isLogos
      />
    </ValidatedPanel>
  );
};

LogoListPortalContainerSection.propTypes = {
  expand: PropTypes.func.isRequired,
  images: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({}))).isRequired,
  containerRef: PropTypes.shape({
    current: PropTypes.shape({}),
  }).isRequired,
  containerState: PropTypes.shape({}),
};

LogoListPortalContainerSection.defaultProps = {
  containerState: {},
};
